// extracted by mini-css-extract-plugin
export default {"container":"Avatar__container--Rj9_V_nbOtUM_yHDzvsA","innerContainer":"Avatar__innerContainer--wsp8lfab3MphA8zDzLRU"};